<template>
    <div>
        <component :is="layout">
            <router-view />
        </component>
    </div>

    <Toast position="top-right"></Toast>

    <Toast position="top-right" group="retailSaleCancelRequest" :closable="true">
        <template #message="slotProps">
            <div class="cursor-pointer" @click="goToRetailSale">
                <div class="font-bold mb-1">{{ slotProps.message.summary }}</div>
                <div>{{ slotProps.message.detail }}</div>
            </div>
        </template>
    </Toast>

    <Toast position="bottom-right" group="supportChat" :closable="true" class="p-custom-toast">
        <template #message="slotProps">
            <div class="flex flex-column w-full">
                <div class="text-center">
                    <div class="mt-3">
                        <i class="ri ri-message-2-line" style="font-size: 3rem"></i>
                    </div>
                    <div class="ml-3 mt-2 mr-6">
                        <a>{{ slotProps.message.detail }}</a>
                        <div class="mt-2">
                            <i class="pi pi-arrow-right mr-1" /><a href="/doctor-chat">{{ slotProps.message.summary }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </Toast>

    <Toast position="bottom-right" group="bc" :closable="true" class="p-custom-toast p-custom-close-icon">
        <template #message="slotProps">
            <div class="flex flex-column w-full">
                <div class="text-center">
                    <h4 class="mb-0">{{ slotProps.message.name }}</h4>
                    <div>is calling you</div>
                    <Avatar :image="slotProps.message.avatar" size="xlarge" class="my-avatar my-5" />
                </div>
                <div class="grid p-fluid">
                    <div class="col-6">
                        <Button class="p-button-danger" label="Decline" @click="onReject(slotProps.message.id)"></Button>
                    </div>
                    <div class="col-6">
                        <Button class="p-button-success" label="Accept" @click="onConfirm(slotProps.message.id, slotProps.message.chatId, slotProps.message.appointmentId)"></Button>
                    </div>
                </div>
            </div>
        </template>
    </Toast>

    <ScrollTop :threshold="200" class="custom-scrolltop" />
</template>

<script>
import { ref } from 'vue'
import EventBus from '@/libs/AppEventBus'
import LayoutDefault from '@/layouts/default/App.vue'
import LayoutCms from '@/layouts/cms/App.vue'
import Toast from 'primevue/toast'
import Button from 'primevue/button'
import ScrollTop from 'primevue/scrolltop'
import Avatar from 'primevue/avatar'
import { db } from '@/libs/firebase'
import { globalService } from './service/globalService'
import { service } from './modules/doctor_chat/service'
import { useChatCountStore } from '@/store/chatCountStore'
import { useAuthStore } from '@/modules/auth/authStore'
import GetStreamService from '@/libs/getstream'

export default {
    themeChangeListener: null,
    components: { Avatar, LayoutDefault, LayoutCms, Toast, ScrollTop, Button },
    computed: {
        layout() {
            if (this.$route.meta.layout === 'default') return 'layout-default'
            if (this.$route.meta.layout === 'cms') return 'layout-cms'
            return 'layout-full'
        }
    },
    watch: {
        '$route.path': {
            handler() {
                if (this.user !== 'undefined' && this.user.role == 'doctor' && this.user.doctor.support_chat_enable) this.fetchDoctorChatRoom()
            },
            immediate: true
        }
    },
    data() {
        return {
            audio: new Audio(require('@/assets/sounds/ringtone.mp3')),
            supportChatAudio: new Audio(require('@/assets/sounds/drop_don.mp3')),
            user: localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : 'undefined',
            service: globalService,
            chatService: service,
            // id of the incoming call shown in the "bc" toast
            incomingCallId: null,
            // Firestore listeners for the support chat badge (re-created on route change)
            supportChatUnsubscribers: []
        }
    },

    mounted() {
        // if (this.user !== 'undefined' && this.user.role == 'doctor' && this.user.doctor.support_chat_enable)
        // this.fetchDoctorChatRoom()

        if (this.$appState.darkTheme) {
            const elementId = 'theme-link'
            const linkElement = document.getElementById(elementId)
            const cloneLinkElement = linkElement.cloneNode(true)
            const newThemeUrl = linkElement.getAttribute('href').replace('lara-light-indigo', this.$appState.theme)

            cloneLinkElement.setAttribute('id', elementId + '-clone')
            cloneLinkElement.setAttribute('href', newThemeUrl)
            cloneLinkElement.addEventListener('load', () => {
                linkElement.remove()
                cloneLinkElement.setAttribute('id', elementId)
            })
            linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling)
        }

        this.themeChangeListener = (event) => {
            const elementId = 'theme-link'
            const linkElement = document.getElementById(elementId)
            const cloneLinkElement = linkElement.cloneNode(true)
            const newThemeUrl = linkElement.getAttribute('href').replace(this.$appState.theme, event.theme)

            cloneLinkElement.setAttribute('id', elementId + '-clone')
            cloneLinkElement.setAttribute('href', newThemeUrl)
            cloneLinkElement.addEventListener('load', () => {
                linkElement.remove()
                cloneLinkElement.setAttribute('id', elementId)
            })
            linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling)

            this.$appState.theme = event.theme
            this.$appState.darkTheme = event.dark
        }

        EventBus.on('theme-change', this.themeChangeListener)
        EventBus.on('show-toast', this.showToast)
        EventBus.on('show-call-notification', this.showCallNotification)
        // EventBus.on('healthnews-toast', this.healthnewsToast)
        EventBus.on('support-chat-toast', this.supportChatToast)
        EventBus.on('stop-call-notification', this.stopCallNotification)
        EventBus.on('support-chat-message', this.onSupportChatMessage)
    },
    methods: {
        showToast(event) {
            this.$toast.add({
                severity: event.severity,
                summary: event.summary,
                detail: event.detail,
                life: 3000,
                group: event.group
            })
        },

        goToRetailSale() {
            this.$toast.removeGroup('retailSaleCancelRequest')
            this.$router.push('/retail_sale')
        },

        healthnewsToast(event) {
            //this.playNotiSong()
            this.$toast.removeGroup('healthnews')
            this.$toast.add({
                severity: event.severity,
                summary: event.summary,
                detail: event.detail,
                life: 3000,
                group: 'healthnews'
            })
        },

        supportChatToast(event) {
            this.playNotiSong('supportChat')
            this.$toast.removeGroup('supportChat')
            this.$toast.add({
                severity: event.severity,
                summary: event.summary,
                detail: event.detail,
                group: 'supportChat',
                life: 1000
            })
        },

        showCallNotification(event) {
            if (this.$route.name == 'videoChatDetail') {
                this.onReject(event.id)
                return
            }

            this.incomingCallId = event.id
            this.playNotiSong()
            this.$toast.removeGroup('bc')
            this.$toast.add({
                severity: '',
                avatar: event.avatar,
                name: event.name,
                id: event.id,
                chatId: event.chatId,
                appointmentId: event.appointmentId,
                group: 'bc',
                life: 60000,
                call: event
            })
        },
        async onConfirm(id, chatId, appointmentId) {
            this.incomingCallId = null
            this.pauseNotiSong()
            this.$toast.removeGroup('bc')
            this.$router.push({
                name: 'videoChatDetail',
                params: { room: id, chat_id: chatId, appointment_id: appointmentId },
                query: { incoming: true }
            })
        },
        async onReject(id) {
            if (this.incomingCallId === id) {
                this.incomingCallId = null
                this.pauseNotiSong()
                this.$toast.removeGroup('bc')
            }
            try {
                await GetStreamService.rejectCall(id)
            } catch (error) {
                console.error('Failed to reject call:', error)
            }
        },
        async fetchDoctorChatRoom() {
            console.log('enter once')
            const authStore = useAuthStore()
            const authUser = authStore.getUserData
            const store = useChatCountStore()
            store.setChatCount(false)
            // drop the listeners of the previous route
            this.unsubscribeSupportChats()
            const response = await this.chatService.fetchChatRoomList({
                agent_id: authUser.id,
                page: 1,
                per_page: 10
            })

            const anwseredList = ref([])
            anwseredList.value.push(...(response?.data?.data ?? []))
            // Process all chat rooms for notifications
            anwseredList.value.map((chatUser) => {
                try {
                    const messageRef = db.collection('doctor_chat').doc(chatUser.chat_room_id.toString()).collection('messages').orderBy('time', 'desc').limit(1)
                    const unsubscribe = messageRef.onSnapshot((onSnapshot) => {
                        if (onSnapshot.size > 0) {
                            onSnapshot.forEach((doc) => {
                                // if(chatUser.status === 'in-progress')
                                // {
                                //     if(doc.data().members && doc.data().members.includes(this.user.id.toString()) && !doc.data().read_by.includes(this.user.id.toString()))
                                //     {
                                //         this.supportChatToast({
                                //             severity: 'info',
                                //             summary: 'Go to Chat',
                                //             detail: 'You have ' + onSnapshot.size + ' chat notification !'
                                //         })
                                //     }
                                // }
                                if (!(doc.data().read_by || []).includes(this.user.id.toString())) store.setChatCount(true)
                            })
                        } else {
                            store.setChatCount(false)
                        }
                    })
                    this.supportChatUnsubscribers.push(unsubscribe)
                } catch (e) {
                    console.error('Error reading document: ', e)
                }
            })
        },
        // new support chat message notification: the room may not be among the loaded ones
        onSupportChatMessage() {
            clearTimeout(this.supportChatRefreshTimer)
            this.supportChatRefreshTimer = setTimeout(() => {
                if (this.user !== 'undefined' && this.user.role == 'doctor' && this.user.doctor?.support_chat_enable) this.fetchDoctorChatRoom()
            }, 500)
        },
        unsubscribeSupportChats() {
            this.supportChatUnsubscribers.forEach((unsubscribe) => unsubscribe())
            this.supportChatUnsubscribers = []
        },
        playNotiSong(type = null) {
            const audio = type == 'supportChat' ? this.supportChatAudio : this.audio
            // the browser may block autoplay until the user interacted with the page
            audio.play().catch((error) => console.error('Failed to play notification sound:', error))
        },
        pauseNotiSong() {
            this.audio.pause()
        },
        stopCallNotification(event) {
            // another call may be ringing in the toast by now
            if (event?.id && this.incomingCallId && event.id !== this.incomingCallId) return
            this.incomingCallId = null
            this.pauseNotiSong()
            this.$toast.removeGroup('bc')
        }
    },
    beforeUnmount() {
        EventBus.off('theme-change', this.themeChangeListener)
        EventBus.off('show-toast', this.showToast)
        // EventBus.off('healthnews-toast', this.healthnewsToast)
        EventBus.off('support-chat-toast', this.supportChatToast)
        EventBus.off('show-call-notification', this.showCallNotification)
        EventBus.off('stop-call-notification', this.stopCallNotification)
        EventBus.off('support-chat-message', this.onSupportChatMessage)
        clearTimeout(this.supportChatRefreshTimer)
        this.unsubscribeSupportChats()
    }
}
</script>

<style lang="scss">
.p-scroll-top.p-link {
    background: var(--primary-color);
}
.p-custom-toast .p-toast-message {
    background: white;
}
.p-custom-close-icon .p-toast-icon-close {
    display: none !important;
}
.my-avatar img {
    border-radius: 1rem;
}
</style>
